import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import Select from 'react-select';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

import LineChart from '../../reusable/chart/chart.component';
import Spinner from '../../reusable/spinner/spinner.component';

import Client from '../../../tools/client.js';
import Tools from '../../../tools/tools.js';

import {
  ContentContainer,
  MainContainer,
  RowContainer,
  Subtitle,
  Title
} from '../../../styles/component.styles.jsx';

const client = new Client();
const tools = new Tools();

const CustomerMetrics = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentCount, setCurrentCount] = useState(0);
  const [currentDateRange, setCurrentDateRange] = useState({});
  const [dateRangeType, setDateRangeType] = useState({ value: 'all', label: 'All' });
  const [dateRangePosition, setDateRangePosition] = useState(0);

  const options = [
    { value: 'all', label: 'All' },
    { value: 'day', label: 'Day' },
    { value: 'week', label: 'Week' },
    { value: 'month', label: 'Month' },
    { value: 'year', label: 'Year' }
  ];

  useEffect(() => {
    changeDateRange();
    // eslint-disable-next-line
  }, [dateRangeType, dateRangePosition]);

  const getAllData = async () => {
    setLoading(true);
    const res = await client.getCustomersByDateRange();
    const sortedData = tools.sortByDateAscending(res);
    setData(sortedData);
    let count = 0;
    sortedData.forEach(day => count += parseInt(day.count));
    setTotalCount(count);
    setCurrentCount(count);
    setLoading(false);
  };

  const changeDateRange = async () => {
    if (dateRangeType.value === 'all') {
      await getAllData();
      return;
    }

    setLoading(true);
    const now = dayjs();
    let adjusted = now;

    switch (dateRangeType.value) {
      case 'day':
        adjusted = now.subtract(dateRangePosition, 'day');
        break;
      case 'week':
        adjusted = now.subtract(dateRangePosition, 'week');
        break;
      case 'month':
        adjusted = now.subtract(dateRangePosition, 'month');
        break;
      case 'year':
        adjusted = now.subtract(dateRangePosition, 'year');
        break;
      default:
        break;
    }

    const start = adjusted.startOf(dateRangeType.value).format('YYYY-MM-DD');
    const end = adjusted.endOf(dateRangeType.value).format('YYYY-MM-DD');
    setCurrentDateRange({ start, end });

    const res = await client.getCustomersByDateRange(start, end);
    const sortedData = tools.sortByDateAscending(res);
    let count = 0;
    sortedData.forEach(day => count += parseInt(day.count));
    setCurrentCount(count);
    setData(sortedData);
    setLoading(false);
  };

  const goBack = () => {
    if (dateRangeType.value !== 'all') {
      setDateRangePosition(prev => prev + 1);
    }
  };

  const goForward = () => {
    if (dateRangeType.value !== 'all' && dateRangePosition > 0) {
      setDateRangePosition(prev => prev - 1);
    }
  };

  const changeDateRangeType = (newType) => {
    setDateRangePosition(0);
    setDateRangeType(newType);
  };

  return (
    <MainContainer>
      {loading ? (
        <Spinner />
      ) : (
        <ContentContainer>
          <Title>Customer Metrics</Title>
          <RowContainer>
            <FaAngleLeft onClick={goBack} style={{ cursor: 'pointer' }} />
            <Select
              value={dateRangeType}
              onChange={changeDateRangeType}
              options={options}
            />
            <FaAngleRight onClick={goForward} style={{ cursor: 'pointer' }} />
          </RowContainer>
          <Subtitle>Total Count: {totalCount}</Subtitle>
          {dateRangeType.value !== 'all' && (
            <>
              <Subtitle>Current Count: {currentCount}</Subtitle>
              <Subtitle>
                {dateRangeType.value === 'day' && dayjs(currentDateRange.start).format('dddd MM/DD/YYYY')}
                {dateRangeType.value === 'week' && `${dayjs(currentDateRange.start).format('MM/DD/YYYY')} - ${dayjs(currentDateRange.end).format('MM/DD/YYYY')}`}
                {dateRangeType.value === 'month' && dayjs(currentDateRange.start).format('MMMM YYYY')}
                {dateRangeType.value === 'year' && dayjs(currentDateRange.start).format('YYYY')}
              </Subtitle>
            </>
          )}
          <RowContainer>
            <LineChart
              title=""
              data={data}
              datasets={[
                { label: 'New Customers', key: 'count', color: '#9966FF' }
              ]}
              getLabel={(item) => dayjs(item.date).format('M/D/YYYY')}
            />
          </RowContainer>
        </ContentContainer>
      )}
    </MainContainer>
  );
};

export default CustomerMetrics;
